import { takeLatest, select } from 'redux-saga/effects';
import { browserHistory } from 'react-router';

import { createAction } from '../../utils/redux/createAction';
import { loggedUserSelector } from '../context/selectors';
import { PROFILE } from '../../constants/routes';

export const MY_PROFILE_REDIRECT_TYPES = {
  GO_TO_PROFILE: 'my-profile-redirect/go-to-profile',
};

export const myProfileRedirectActions = {
  goToProfile: createAction(MY_PROFILE_REDIRECT_TYPES.GO_TO_PROFILE),
};

function* redirectToCurrentProfile() {
  const user = yield select(loggedUserSelector);

  const { id, primaryProviderProfile } = user || {};
  const role = primaryProviderProfile ? 'provider' : 'patient';
  browserHistory.push(`/${PROFILE}/${id}/${role}`);
}

export function* profileRedirectSaga() {
  yield takeLatest(
    MY_PROFILE_REDIRECT_TYPES.GO_TO_PROFILE,
    redirectToCurrentProfile,
  );
}



// WEBPACK FOOTER //
// ./src/redux/profiles/my-profile-redirect.js